module.exports = __webpack_public_path__ + "static/media/WorkFlowIcon.9a50108d.png";